import { useMutation } from "react-query";
import http from "infra/http";
import { ReservaForm } from "../typings";

function useSaveReserva() {
  return useMutation(
    (data: ReservaForm) => {
      return http.post(`/v1/reserva`, data);
    },
    { retry: false }
  );
}

export default useSaveReserva;
